/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, type ComponentChildren } from 'preact'
import { useContext, useState } from 'preact/hooks'

interface PaymentsContextProps {
	selectedPlan: string | null
	setSelectedPlan: (plan: string | null) => void
	clientSecret: string
	setClientSecret: (secret: string) => void
	returnUrl: string
	setReturnUrl: (url: string) => void
}

const PaymentsContext = createContext<PaymentsContextProps | undefined>(
	undefined
)

export const PaymentsProvider = ({
	children
}: {
	children: ComponentChildren
}) => {
	const [selectedPlan, setSelectedPlan] = useState<string | null>(null)
	const paramsSecret = new URLSearchParams(window.location.search).get(
		'payment_intent_client_secret'
	)
	const returnUrlParams = new URLSearchParams(window.location.search).get(
		'return_url'
	)

	const [clientSecret, setClientSecret] = useState(paramsSecret || '')
	const [returnUrl, setReturnUrl] = useState(returnUrlParams || '')

	return (
		<PaymentsContext.Provider
			value={{
				selectedPlan,
				setSelectedPlan,
				clientSecret,
				setClientSecret,
				returnUrl,
				setReturnUrl
			}}
		>
			{children}
		</PaymentsContext.Provider>
	)
}

export const usePayments = () => {
	const context = useContext(PaymentsContext)
	if (!context) {
		throw new Error('usePayments must be used within a PaymentsProvider')
	}
	return context
}
